import React from 'react';
import { Column, Columns } from '@homeexchange/design';
import styles from './homeLoading.module.scss';
import { useWindowSize } from '@homeexchange/shared';
export function HomeLoading() {
    var width = useWindowSize().width;
    var isLargeDesktop = width >= 1560;
    var placeholderItems = Array(isLargeDesktop ? 9 : 6).fill(null);
    var groupedPlaceholders = [];
    for (var i = 0; i < placeholderItems.length; i += isLargeDesktop ? 3 : 2) {
        groupedPlaceholders.push(placeholderItems.slice(i, i + (isLargeDesktop ? 3 : 2)));
    }
    return (React.createElement("div", { className: styles['skeleton-container'] },
        React.createElement("div", { className: styles.skeletonResultsCount }),
        groupedPlaceholders.map(function (group, groupIndex) { return (React.createElement(Columns, { key: "skeleton-group-".concat(groupIndex), className: "mb-4" }, group.map(function (_, itemIndex) { return (React.createElement(Column, { size: isLargeDesktop ? 4 : 6, key: "skeleton-item-".concat(groupIndex, "-").concat(itemIndex) },
            React.createElement("div", { className: styles.skeletonCard },
                React.createElement("div", { className: styles.skeletonImage }),
                React.createElement("div", { className: styles.skeletonContent },
                    React.createElement("div", { className: styles.skeletonTitle }),
                    React.createElement("div", { className: styles.skeletonLocation }),
                    React.createElement("div", { className: styles.skeletonDetail }),
                    React.createElement("div", { className: styles.skeletonAvailability }),
                    React.createElement("div", { className: styles.skeletonPrice }))))); }))); })));
}
